module.exports = __webpack_public_path__ + "static/LEPA News 20200714 Abacus Data Analyser-5be651b5057fceb8c57beb15abdc4cab.jpg";